import { useRef } from "react";
import { FaCloudUploadAlt } from "react-icons/fa"; // Usando react-icons para íconos
import "./styles.css";

const InputFileRHF = ({
  register,
  accept = "image/* ,application/pdf",
  campo,
  setValue,
  multiple = null,
  proyect = null,
  setPreviews = null,
}) => {
  const fileInputRef = useRef(null);

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    // const files = event.target.files;
    const files = Array.from(event.target.files);
    if (files.length > 0) {
      // console.log(files)
      // console.log("Archivo seleccionado: ", files[0].name);
      // console.log(files[0])
      // setValue(campo, files, { shouldValidate: true });
      const previews = files.map((file) => ({
        name: file.name,
        url: URL.createObjectURL(file),
      }));
      setPreviews(previews);

      setValue(campo, files, { shouldDirty: true, shouldValidate: true });
    }
  };

  // console.log(campo)

  return (
    <div className="file-input-container">
      {/* Usamos un ícono en lugar de texto */}
      {proyect == "arbolado" ? (
        <div className="file-input-icon-arbolado " onClick={handleClick}>
          <FaCloudUploadAlt size={25} color="#4CAF50" />
          <p className="m-0">Subir archivo </p>
        </div>
      ) : (
        <div className="file-input-icon" onClick={handleClick}>
          <FaCloudUploadAlt size={50} color="#4CAF50" />
          <p>Subir archivo</p>
        </div>
      )}

      <input
        accept={accept}
        type="file"
        ref={fileInputRef}
        multiple={multiple}
        // {...register(campo)}
        onChange={handleFileChange}
        style={{ display: "none" }} // Ocultamos el input
      />
    </div>
  );
};

export default InputFileRHF;
